import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AbstractPageScreenService } from '../page-screen/abstract-page-screen.service';
import { CustomerStatus } from '../../../domain';
import { AbstractGatewayService } from '../../services';

@Component({
  selector: 'osn-shared-carousel-title',
  templateUrl: './carousel-title.component.html',
  styleUrls: ['./carousel-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselTitleComponent implements OnInit {
  @Input() public title: string;
  @Input() public link: string;
  @Input() public replaceUrl: boolean;
  @Input() public canNavigateOnTitleClick: boolean;
  @Output() public carouselTitleClick = new EventEmitter<void>();
  @Output() public exploreAllClick = new EventEmitter<void>();

  public isTitleClickable$: Observable<boolean>;

  constructor(
    private readonly abstractPageScreenService: AbstractPageScreenService,
    private readonly router: Router,
    private readonly gatewayService: AbstractGatewayService
  ) {}

  public onCarouselTitleClick(): void {
    this.carouselTitleClick.emit();
  }

  public onExpandAllClick(): void {
    const isGenrePage = this.router.url.split('/')[2] === 'genre';
    this.abstractPageScreenService.measureCarouselTitleExploreAllClick(this.title, isGenrePage);
    this.exploreAllClick.emit();
  }

  public ngOnInit(): void {
    this.isTitleClickable$ = this.gatewayService
      .getCustomerStatus$()
      .pipe(map((customerStatus) => customerStatus !== CustomerStatus.ANONYMOUS && this.canNavigateOnTitleClick));
  }
}
